// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"modal-header___1ayf_","icon":"icon___3SP5l","title":"title___H-Dh6","modal-footer":"modal-footer___15SHk","cancel":"cancel___3M0Ir"};